import React, { FC } from 'react';
import { BaseButtonProps, ButtonWithLoader } from 'src/common/components/Button';
import styled from 'styled-components';
import { useJoinElearningMutation } from 'src/common/hooks/elearning/useJoinElearningMutation';
import { authActions } from 'src/state/auth/authActions';
import { PostRedirectAction } from 'src/config/postRedirectAction';
import { LoginRoute } from 'src/public/publicRoutes';
import { useIsLoggedIn } from 'src/common/hooks/useIsLoggedIn';
import { useDispatch } from 'react-redux';
import { Elearning } from 'src/common/models/elearning';
import { useGatsbyLikeNavigate } from 'src/common/migration/useGatsbyLikeNavigate';
import { useGatsbyLikeLocation } from 'src/common/migration/useGatsbyLikeLocation';
import { pageContextActions } from 'src/state/pageContext/pageContextActions';

const StyledButton = styled(ButtonWithLoader)`
  padding: 0.5625rem 2.4375rem;
  border: none;
`;

export interface JoinElearningButtonProps {
  elearning: Elearning;
}

export const JoinElearningButton: FC<JoinElearningButtonProps & BaseButtonProps> = ({
  elearning,
  ...rest
}) => {
  const location = useGatsbyLikeLocation();
  const navigate = useGatsbyLikeNavigate();
  const { isLoggedIn } = useIsLoggedIn();
  const dispatch = useDispatch();
  const joinMutation = useJoinElearningMutation(elearning.id);

  const handleOnClick = () => {
    if (isLoggedIn) {
      joinMutation.mutate();
    } else {
      dispatch(
        authActions.setRedirectUrl({
          action: PostRedirectAction.JoinElearning,
          pathname: location.pathname,
          publicRoute: true,
          query: location.query,
        }),
      );
      dispatch(
        pageContextActions.setAuthCourseExcerpt({
          image: elearning.image,
          title: elearning.title,
        }),
      );
      navigate(LoginRoute, { replace: true });
    }
  };

  return (
    <StyledButton
      loading={joinMutation.isLoading}
      kind="primary"
      onClick={handleOnClick}
      size="small"
      {...rest}
    >
      <span style={{ verticalAlign: 'middle' }}>Rozpocznij e-learning</span>
    </StyledButton>
  );
};
